import { i18n } from '@js/i18n'
import { documentTypes } from '@const'

export default {
  form: {
    website: '',
    companyName: '',
    industry: '',
    phoneNumber: '',
    docs: {
      [documentTypes.kycOriginationCertificate]: null
    }
  },
  requiredDocs: [documentTypes.kycOriginationCertificate],
  rows: [
    [
      {
        "heading": i18n.kyc_submit_company_documents()
      }
    ],
    [
      {
        "subheading": i18n.kyc_corp_step1_subhead()
      }
    ],
    [
      {
        "model": "website",
        "name": "company-website",
        "id":  "kyc-company-website",
        "label": i18n.kyc_company_website(),
        "field": "text",
        "required": true,
        "validate": "required"
      }
    ],
    [
      {
        "model": "companyName",
        "name": "company-name",
        "id":  "kyc-company-name",
        "label": i18n.com_name(),
        "field": "text",
        "required": true,
        "validate": "required"
      }
    ],
    [
      {
        "model": "industry",
        "name": "company-industry",
        "id":  "kyc-company-industry",
        "label": i18n.kyc_company_industry(),
        "field": "select",
        "required": true,
        "values": "industries",
        "validate": "required"
      }
    ],
    [
      {
        "model": "phoneNumber",
        "name": "company-phone-number",
        "id":  "company-phone-number",
        "label": i18n.kyc_company_phone(),
        "field": "text",
        "type": "tel",
        "required": true,
        "validate": "required"
      }
    ],
    [
      {
        "name": "company-incorporation-certificate",
        "id":  "company-incorporation-certificate",
        "label": i18n.kyc_upload_origination_certificate(),
        "field": "file",
        "side": "front",
        "fileType": "image",
        "required": true,
        "type": documentTypes.kycOriginationCertificate,
        "validate": "required"
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/syndicate/step-1.general.schema.js